import cloneDeep from 'lodash/cloneDeep';
import { GET_TABLE } from '../../site/site-table/table.ui.store';
import { SelectWorkspacePoints } from '../points.actions';
import { TPointsByWorkspace } from '../points.model';
import { addSelectedPoint } from '../selected-points';

export function selectWorkspacePoints(
  oldState: TPointsByWorkspace,
  action: SelectWorkspacePoints,
): TPointsByWorkspace {
  const state = cloneDeep(oldState);
  const visiblePointsIds = GET_TABLE().getVisiblePointIds();

  state[action.payload.workspaceId].entities.forEach((point) => {
    if (visiblePointsIds.includes(point._id)) {
      addSelectedPoint(point._id);
    }
  });

  return state;
}
